module.exports = __webpack_public_path__ + "img/all-zones-inactive.eca16258.svg";